export const en = {
  // Header
  "nav.check_booking": "Check Booking",
  "nav.admin": "Admin",
  "nav.book_now": "Book Now",
  "nav.driver": "Driver",

  // Hero
  "hero.badge": "J1 Visa Student Transportation",
  "hero.title": "Easy Transportation",
  "hero.subtitle": "Your Trusted Ride from Chicago Airports to Wisconsin",
  "hero.description": "Safe, reliable, and affordable transportation for J1 visa students. Book your airport pickup or return trip today!",
  "hero.book_trip": "Book Your Trip",
  "hero.check_status": "Check Booking Status",

  // Pricing
  "pricing.title": "Transportation Pricing",
  "pricing.subtitle": "All prices in USD",
  "pricing.ohare_mke": "Pick Up (O'Hare / Milwaukee)",
  "pricing.midway": "Pick Up (Midway)",
  "pricing.madison": "Madison to Wisconsin Dells",
  "pricing.return": "Discount For Return",
  "pricing.shared": "Shared Ride",
  "pricing.private": "Private Ride",
  "pricing.per_person": "per person",
  "pricing.after_deposit": "after $20 deposit",
  "pricing.without_deposit": "without deposit",
  "pricing.flat_rate": "flat rate",
  "pricing.per_suitcase": "Per suitcase",
  "pricing.carry_on": "Carry-on",
  "pricing.free": "FREE",
  "pricing.with_shipping": "Return + ship with us",
  "pricing.special_deal": "Special Deal!",
  "pricing.midway_contact": "Contact us for Midway (MDW) prices",
  "pricing.waterpark_note": "Prices may differ for Three Bears Water Park or other destinations.",
  "pricing.contact_us": "Contact us",
  "pricing.guidelines_title": "How Our Pricing Works",
  "pricing.guidelines_deposit": "$20 deposit per person secures your booking. The remaining balance is due on trip day.",
  "pricing.guidelines_shared": "2 or more passengers traveling on the same day to the same airport get the shared ride rate.",
  "pricing.guidelines_solo": "Solo riders (only passenger that day) may be charged a slightly higher rate.",
  "pricing.guidelines_suitcase": "1 suitcase is included free on return trips. Each additional suitcase is $5.",
  "pricing.guidelines_payment": "We accept Card, Cash, and Zelle payments.",

  // Booking Requirements
  "requirements.title": "Booking Requirements",
  "requirements.pickup": "We offer pickups twice within 24 hours unless otherwise notified. Plan ahead and book accordingly!",
  "requirements.deposit": "A non-refundable deposit of $3,200 JMD (or $20 USD) is required before you can be added to the schedule.",
  "requirements.seamless": "Secure your spot by making your deposit in advance to avoid any delays.",
  "requirements.final_payment": "The remaining balance is due before entering the vehicle.",

  // Special request
  "special.title": "Destination Not Listed?",
  "special.description": "We offer special request rides to destinations not on our regular routes. Contact us for a custom quote!",
  "special.call": "Call",
  "special.whatsapp": "WhatsApp Us",

  // Features
  "features.title": "Why Choose Easy Transportation?",
  "features.subtitle": "Trusted by thousands of J1 students every summer",
  "features.easy_booking": "Easy Booking",
  "features.easy_booking_desc": "Only $3,200 JMD ($20 USD) deposit required. Pay via bank transfer, card, PayPal, or Zelle.",
  "features.safe": "Safe & Reliable",
  "features.safe_desc": "Professional drivers, comfortable vehicles, and 24/7 support for J1 students.",
  "features.flexible": "Flexible Schedule",
  "features.flexible_desc": "Book arrival and return trips. First suitcase free on returns!",

  // Video
  "video.badge": "See Us In Action",
  "video.title": "Your Journey Starts Here",
  "video.subtitle": "Watch J1 students from Jamaica & Dominican Republic begin their adventure",
  "video.book_now": "Book Your Ride Now",

  // Booking Page
  "booking.title": "Book Your Trip",
  "booking.step": "Step",
  "booking.of": "of",
  "booking.trip_type": "Trip Type",
  "booking.arrival": "Arrival (Airport Pickup)",
  "booking.return": "Return (To Airport)",
  "booking.ride_type": "Ride Type",
  "booking.shared_ride": "Shared Ride",
  "booking.shared_desc": "Share with other passengers on the same route",
  "booking.private_ride": "Private Ride",
  "booking.private_desc": "Exclusive vehicle just for you",
  "booking.pickup_location": "Pickup Airport",
  "booking.select_airport": "Select Airport",
  "booking.travel_date": "Travel Date",
  "booking.travel_time": "Expected Arrival Time",
  "booking.departure_time": "Departure Time",
  "booking.flight_number": "Flight Number",
  "booking.airline": "Airline",
  "booking.terminal": "Arrival Terminal",
  "booking.full_name": "Full Name",
  "booking.whatsapp": "WhatsApp Number",
  "booking.email": "Email Address",
  "booking.housing": "Housing Unit",
  "booking.select_housing": "Select Housing",
  "booking.custom_address": "Enter Custom Address",
  "booking.num_passengers": "Number of Passengers",
  "booking.suitcases": "Total Suitcases",
  "booking.shipping": "Using T&M Courier Services?",
  "booking.payment": "Payment Method",
  "booking.referral": "Referral Code",
  "booking.next": "Next",
  "booking.previous": "Previous",
  "booking.submit": "Complete Booking",
  "booking.processing": "Processing...",
  "booking.start_over": "Start Over",
  "booking.first_time": "First Time Traveling",
  "booking.returning": "Returning Customer",
  "booking.confirmation_number": "Confirmation Number",

  // Pricing Summary
  "pricing_summary.title": "Pricing Summary",
  "pricing_summary.trip_price": "Trip Price",
  "pricing_summary.luggage_fee": "Luggage Fee",
  "pricing_summary.deposit": "Deposit",
  "pricing_summary.per_person": "per person",
  "pricing_summary.discount": "Referral Discount",
  "pricing_summary.total_now": "Total Due Now",
  "pricing_summary.balance": "Remaining Balance",

  // Success
  "success.title": "Booking Confirmed!",
  "success.confirmation": "Confirmation Number",
  "success.details": "Booking Details",
  "success.whatsapp_optin": "Get updates via WhatsApp",
  "success.home": "Back to Home",

  // Driver
  "driver.title": "Driver Dashboard",
  "driver.login": "Driver Login",
  "driver.phone": "Phone Number",
  "driver.pin": "PIN Code",
  "driver.sign_in": "Sign In",
  "driver.trips_today": "Today's Trips",
  "driver.upcoming": "Upcoming Trips",
  "driver.passengers": "passengers",
  "driver.suitcases": "suitcases",
  "driver.navigate": "Navigate to Pickup",
  "driver.contact": "Contact Passenger",
  "driver.complete": "Complete Trip",
  "driver.logout": "Logout",
  "driver.no_trips": "No trips scheduled",

  // Common
  "common.loading": "Loading...",
  "common.error": "Something went wrong",
  "common.save": "Save",
  "common.cancel": "Cancel",
  "common.close": "Close",
  "common.details": "Details",
  "common.status": "Status",
  "common.date": "Date",
  "common.time": "Time",
  "common.price": "Price",
  "common.passenger": "Passenger",
  "common.passengers": "Passengers",
};
